// Management Fee APIs

// Period Management
/**
 * @function ApiClient#AddMgmtFeePeriod
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} periodData
 * @param {any} options = {}
 */
export async function AddMgmtFeePeriod(cid, periodData, options = {}) {
  return await this._post(`/community/${cid}/mgmtfee/period`, periodData, options);
}

/**
 * @function ApiClient#UpdateMgmtFeePeriod
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} periodData
 * @param {any} options = {}
 */
export async function UpdateMgmtFeePeriod(cid, periodData, options = {}) {
  return await this._put(`/community/${cid}/mgmtfee/period`, periodData, options);
}

/**
 * @function ApiClient#GetMgmtFeePeriodList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.search
 * @param {any} params.sortBy
 * @param {any} params.sortDesc
 * @param {any} params.page
 * @param {any} params.itemsPerPage
 * @param {any} options = {}
 */
export async function GetMgmtFeePeriodList(cid, { search = "", sortBy = "", sortDesc = "", page = "", itemsPerPage = "" } = {}, options = {}) {
  const url = `/community/${cid}/mgmtfee/period_list?s=${search}&p=${page}&sb=${sortBy}&sd=${sortDesc}&pp=${itemsPerPage}`;
  return await this._get(url, options);
}

/**
 * @function ApiClient#DeleteMgmtFeePeriod
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function DeleteMgmtFeePeriod(cid, pid, options = {}) {
  return await this._delete(`/community/${cid}/mgmtfee/period/${pid}`, options);
}

/**
 * @function ApiClient#OpenMgmtFeePeriod
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function OpenMgmtFeePeriod(cid, pid, options = {}) {
  return await this._put(`/community/${cid}/mgmtfee/period/${pid}/open`, null, options);
}

/**
 * @function ApiClient#CloseMgmtFeePeriod
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function CloseMgmtFeePeriod(cid, pid, options = {}) {
  return await this._put(`/community/${cid}/mgmtfee/period/${pid}/close`, null, options);
}

// Item Management
/**
 * @function ApiClient#GetMgmtFeeItemList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function GetMgmtFeeItemList(cid, pid, options = {}) {
  return await this._get(`/community/${cid}/mgmtfee/period/${pid}/item_list`, options);
}

/**
 * @function ApiClient#AddMgmtFeeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function AddMgmtFeeItem(cid, pid, itemName, options = {}) {
  return await this._post(`/community/${cid}/mgmtfee/period/${pid}/item?t=${itemName}`, null, options);
}

/**
 * @function ApiClient#UpdateMgmtFeeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} items
 * @param {any} options = {}
 */
export async function UpdateMgmtFeeItem(cid, pid, items, options = {}) {
  return await this._put(`/community/${cid}/mgmtfee/period/${pid}/item`, items, options);
}

/**
 * @function ApiClient#DeleteMgmtFeeItem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} itemName
 * @param {any} options = {}
 */
export async function DeleteMgmtFeeItem(cid, pid, itemName, options = {}) {
  return await this._delete(`/community/${cid}/mgmtfee/period/${pid}/item?t=${itemName}`, options);
}

// Bill Management
/**
 * @function ApiClient#GetMgmtFeePeriodBillList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function GetMgmtFeePeriodBillList(cid, pid, options = {}) {
  return await this._get(`/community/${cid}/mgmtfee/period/${pid}/bill_list`, options);
}

/**
 * @function ApiClient#GetMgmtFeePeriodBillPayList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function GetMgmtFeePeriodBillPayList(cid, pid, options = {}) {
  return await this._get(`/community/${cid}/mgmtfee/period/${pid}/bill_pay_list`, options);
}

/**
 * @function ApiClient#UpdateMgmtFeePeriodBill
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} bill
 * @param {any} options = {}
 */
export async function UpdateMgmtFeePeriodBill(cid, pid, bill, options = {}) {
  return await this._put(`/community/${cid}/mgmtfee/period/${pid}/bill`, bill, options);
}

/**
 * @function ApiClient#GetMgmtFeeBillExportXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 */
export function GetMgmtFeeBillExportXlsFileUrl(cid, pid) {
  return `${this._url}/community/${cid}/mgmtfee/period/${pid}/export`;
}

/**
 * @function ApiClient#ImportMgmtFeeBillList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} xlsxFile
 * @param {any} options = {}
 */
export async function ImportMgmtFeeBillList(cid, pid, xlsxFile, options = {}) {
  const formData = new FormData();
  formData.set("Xlsx", xlsxFile);
  return await this._post(`/community/${cid}/mgmtfee/period/${pid}/import`, formData, options);
}

// Payment Management
/**
 * @function ApiClient#PayMgmtFeeBillToStaff
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} bid
 * @param {any} options = {}
 */
export async function PayMgmtFeeBillToStaff(cid, pid, bid, options = {}) {
  return await this._put(`/community/${cid}/mgmtfee/period/${pid}/${bid}/pay_to_staff`, null, options);
}

/**
 * @function ApiClient#CancelPayMgmtFeeBillToStaff
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} bid
 * @param {any} options = {}
 */
export async function CancelPayMgmtFeeBillToStaff(cid, pid, bid, options = {}) {
  return await this._delete(`/community/${cid}/mgmtfee/period/${pid}/${bid}/pay_to_staff`, options);
}

/**
 * @function ApiClient#NotifyPayMgmtFeeBillUnpaid
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 * @param {any} options = {}
 */
export async function NotifyPayMgmtFeeBillUnpaid(cid, pid, options = {}) {
  return await this._post(`/community/${cid}/mgmtfee/period/${pid}/notify_unpaid`, null, options);
}

/**
 * @function ApiClient#GetMgmtFeeBillPayInfoExportXlsFileUrl
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} pid
 */
export function GetMgmtFeeBillPayInfoExportXlsFileUrl(cid, pid) {
  return `${this._url}/community/${cid}/mgmtfee/period/${pid}/export_payinfo`;
}

/**
 * @function ApiClient#UpdateMgmtFeePayData
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} oid
 * @param {any} data
 * @param {any} options = {}
 */
export async function UpdateMgmtFeePayData(cid, oid, data, options = {}) {
  return await this._put(`/pay/sinopac/mgmt_fee/${cid}/${oid}`, data, options);
}
